export const tabsStyles = {
  '.MuiTabs-scroller.MuiTabs-fixed': {
    overflowX: 'scroll !important',
    height: 'fit-content',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  '.MuiTabs-flexContainer': {
    gap: '1rem'
  },
  '&.MuiTabs-root': {
    minWidth: 0,
    minHeight: 0
  },
  '.MuiTabs-indicator': {
    backgroundColor: 'var(--tertiary)'
  }
}

export const tabStyles = {
  color: 'var(--primary)',
  fontWeight: 400,
  fontFamily: 'helvetica-neue-lt-pro',
  textTransform: 'Capitalize',
  padding: '0 0 0.375rem 0',

  '&:focus': {
    outline: 'none'
  },
  '&.Mui-selected': {
    color: 'var(--primary)'
  },
  '&.MuiButtonBase-root': {
    minWidth: 0,
    minHeight: 0
  }
}
